const WishlistPage = {

    render(items) {

        const loading = document.querySelector("[data-wishlist-loading]");
        const grid = document.querySelector("[data-wishlist-grid]");

        if (!grid) return;

        if (loading) {
            loading.style.display = "none";
        }

        if (!items.length) {

            grid.innerHTML = `
                <div class="wishlist-empty">
                    Your wishlist is empty.
                </div>
            `;

            return;
        }

        grid.innerHTML = items.map(item => this.card(item)).join("");

    },

    card(item) {

        return `
            <article class="wishlist-item">

                <a href="/products/${item.handle}" class="wishlist-image">

                    <img
                        src="${item.image}"
                        alt="${item.title}"
                        loading="lazy">

                </a>

                <div class="wishlist-content">

                    <h3>
                        <a href="/products/${item.handle}">
                            ${item.title}
                        </a>
                    </h3>

                    <div class="wishlist-price">
                        ${this.money(item.price)}
                    </div>

                    ${
                        item.available
                        ? ""
                        : `<div class="wishlist-soldout">Sold Out</div>`
                    }

                    <button
                        class="wishlist-remove"
                        data-variant="${item.variantId}">

                        Remove

                    </button>

                </div>

            </article>
        `;

    },

    money(price){

        return new Intl.NumberFormat(
            "id-ID",
            {
                style:"currency",
                currency:"IDR",
                maximumFractionDigits:0
            }
        ).format(price);

    }

};

window.WishlistPage = WishlistPage;